import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import React from "react"
import ConsultationContent from "../../components/consultation/ConsultationContent"
import ConsultationHeader from "../../components/consultation/ConsultationHeader"
import Footer from "../../components/footer/Footer"
import MbpHead from "../../components/head/MbpHead"
import NavBar from "../../components/navigation/NavBar"
import nextI18nextConfig from "../../next-i18next.config"
import {useTranslation} from "next-i18next"
import PropTypes from "prop-types"
import {getPageData} from "../../pageData"

const Consultation = () => {
	const {t} = useTranslation("consultationPage")
	const title = `${t("headerPageName")} "- MyBikePlan"`
	const description = t("headerPageName")

	return (
		<>
			<MbpHead>
				<title>{title}</title>
				<meta name="description"
					content={description}/>
				<meta property="og:title"
					content={title}/>
				<meta name="og:description"
					content={description}/>
			</MbpHead>
			<NavBar/>
			<main>
				<ConsultationHeader/>
				<ConsultationContent/>
			</main>
			<Footer/>
		</>
	)
}

export default Consultation

Consultation.propTypes = {
	bikesList: PropTypes.array
}

export async function getStaticProps({locale}) {
	return {
		props: {
			...(await getPageData(locale, [])),
			...(await serverSideTranslations(locale, ["common", "consultationPage", "URL", "filters", "search"], nextI18nextConfig))
		}
	}
}
